import { FullPageLoader } from 'components/FullPageLoader';
import { AdminsTable } from './components/AdminsTable';
import { useAdminsStore } from 'views/store/useAdminsStore';
import { CreateAdminPopup } from './components/CreateAdminPopup';
import { EditAdminForm } from './components/EditAdminForm';
import { ReadPermissionGate } from 'components/PermissionGate';
import { PERMISSION_RESOURCES } from 'constants/permissions';

export const Admins = () => {
  const { loading } = useAdminsStore();

  return (
    <>
      {loading && <FullPageLoader />}

      <ReadPermissionGate resource={PERMISSION_RESOURCES.ADMINS}>
        <CreateAdminPopup />

        <EditAdminForm />

        <AdminsTable />
      </ReadPermissionGate>
    </>
  );
};
